import axios from 'axios'
import router from '@router/index'
import appendHeaders from '../../utils/appendHeaders'
import moment from 'moment'
import handleUserNotLogged from '@utils/handleUserNotLogged'

const actions = {
    async abuseList ({ commit, dispatch, rootGetters }, { pagination } = { pagination: 1 }) {
        commit('ABUSE_LIST_FETCHING')

        const { ABUSE_LIST: url } = rootGetters['endpoints/endpoints']

        const formData = new FormData()
        formData.append('page', pagination)
        try {
            const { data, status } = await axios({
              method: 'post',
              data: formData,
              url,
              headers: appendHeaders(),
              withCredentials: true,
              validateStatus: () => true,
            })

            const {
                code,
                data: values,
                errors,
            } = data

            if (code !== 'OK' && errors) {
                const issue = { ...data, status }
                throw issue
            }
            const { abuses, ...pagination } = values
            commit('ABUSE_LIST_SUCCESS', { abuses, pagination })
            return abuses
        } catch (err) {
            commit('ABUSE_LIST_ERROR', err)
            handleUserNotLogged(err)(dispatch)
        }
    },
    setSelectedAbuse ({ commit }, payload) {
        commit('SET_SELECTED_ABUSE', payload)
    },
    async addAbuse ({ commit, dispatch, rootGetters }, payload) {
        commit('ADD_ABUSE_FETCHING')

        const { ADD_ABUSE: url } = rootGetters['endpoints/endpoints']

        const form = Object.keys(payload).reduce((acc, item) => {
            acc.append(item, payload[item])
            return acc
          }, new FormData())

        try {
            const { data, status } = await axios({
                method: 'post',
                url,
                data: form,
                headers: appendHeaders(),
                withCredentials: true,
                validateStatus: () => true,
            })
            const { code, errors } = data
            if (code !== 'OK' && errors) {
                const issue = { ...data, status }
                throw issue
            }
            commit('ADD_ABUSE_SUCCESS')
            router.push({ name: 'reports' })
        } catch (err) {
            commit('ADD_ABUSE_ERROR', err)
            handleUserNotLogged(err)(dispatch)
        }
    },
    async updateAbuse ({ commit, dispatch, rootGetters }, payload) {
        commit('UPDATE_ABUSE_FETCHING')

        const { UPDATE_ABUSE: url } = rootGetters['endpoints/endpoints']

        const form = Object.keys(payload).reduce((acc, item) => {
            acc.append(item, payload[item])
            return acc
          }, new FormData())

        try {
            const { data, status } = await axios({
                method: 'post',
                url,
                data: form,
                headers: appendHeaders(),
                withCredentials: true,
                validateStatus: () => true,
            })
            const { code, errors } = data

            if (code !== 'OK' && errors) {
                const issue = { ...data, status }
                throw issue
            }
            commit('UPDATE_ABUSE_SUCCESS')
            router.push({ name: 'reports' })
        } catch (err) {
            commit('UPDATE_ABUSE_ERROR', err)
            handleUserNotLogged(err)(dispatch)
        }
    },
    async showAbuse ({ commit, dispatch, rootGetters }, payload) {
        commit('SHOW_ABUSE_FETCHING')

        const { SHOW_ABUSE: url } = rootGetters['endpoints/endpoints']

        const form = Object.keys(payload).reduce((acc, item) => {
            acc.append(item, payload[item])
            return acc
          }, new FormData())

        try {
            const { data, status } = await axios({
                method: 'post',
                url,
                data: form,
                headers: appendHeaders(),
                withCredentials: true,
                validateStatus: () => true,
            })
            const { code, data: abuse, errors } = data

            if (code !== 'OK' && errors) {
                const issue = { ...data, status }
                throw issue
            }
            commit('SHOW_ABUSE_SUCCESS', abuse)
            return abuse
        } catch (err) {
            commit('SHOW_ABUSE_ERROR', err)
            handleUserNotLogged(err)(dispatch)
        }
    },
}

const mutations = {
    ABUSE_LIST_FETCHING (state) {
        state.fetching = true
        state.error = null
    },
    ABUSE_LIST_SUCCESS (state, { abuses, pagination }) {
        state.abuses = [ ...abuses ]
        state.pagination = { ...pagination }
        state.fetching = false
        state.error = null
        state.hasFetched = true
    },
    SET_SELECTED_ABUSE (state, abuse) {
        state.selected = { ...abuse }
    },
    ABUSE_LIST_ERROR (state, error) {
        state.error = { ...error }
        state.fetching = false
        state.hasFetched = true
    },
    ADD_ABUSE_FETCHING (state) {
        state.fetching = true
        state.error = null
    },
    ADD_ABUSE_SUCCESS (state) {
        state.fetching = false
        state.error = null
    },
    ADD_ABUSE_ERROR (state, error) {
        state.error = { ...error }
        state.fetching = false
    },
    UPDATE_ABUSE_FETCHING (state) {
        state.fetching = true
        state.error = null
    },
    UPDATE_ABUSE_SUCCESS (state) {
        state.fetching = false
        state.error = null
    },
    UPDATE_ABUSE_ERROR (state, error) {
        state.error = { ...error }
        state.fetching = false
    },
    SHOW_ABUSE_FETCHING (state) {
        state.fetching = true
        state.error = null
    },
    SHOW_ABUSE_SUCCESS (state, abuse) {
        state.fetching = false
        state.error = null
        state.selected = { ...abuse }
    },
    SHOW_ABUSE_ERROR (state, error) {
        state.error = { ...error }
        state.fetching = false
    },
}

const state = {
    error: null,
    hasFetched: false,
    fetching: false,
    abuses: null,
    selected: null,
    pagination: {
        page: 1,
        pages: 1,
    },
}

const getters = {
    abuses: state => {
        if (!state.abuses) {
            return []
        }
        return state.abuses.map(({
            // eslint-disable-next-line camelcase
            date_time_creation,
            ...rest }) => ({
            ...rest,
            createdAt: moment.unix(date_time_creation).format('DD MMMM YYYY'),
        }))
    },
    error: state => state.error,
    selectedAbuse: state => state.selected,
    fetching: state => state.fetching,
    hasFetchedAbuseList: state => state.hasFetched,
    totalElements: state => state.pagination && state.pagination.records,
    page: state => state.pagination && state.pagination.page,
    pages: state => state.pagination && state.pagination.pages,
    elementsPerPage: state => state.pagination && state.pagination.elements,
}

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
}
